import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CriteriaService } from 'src/app/services/index.service';
import { ISingleSortingQuestion } from 'src/app/shared/interfaces/single-sorting-question';
import { hatchFade } from '../hatch-skin/hatch-animation';
import { fadeIn, heightZero, shadowAnimation } from 'src/app/shared/animation/animation';

interface IOption{
  id:number;
  type:string;
  additional_fields:{text:string};
}
interface IData{
  isUnknown:boolean;
  comment:string|null;
}
interface IAnswer{
  id:number;
  answer:number[];
  valid:boolean;
  isUnknown:boolean;
}



@Component({
  selector: 'app-sorting',
  templateUrl: './sorting.component.html',
  styleUrls: ['./sorting.component.scss'],
  animations: [hatchFade, shadowAnimation, fadeIn, heightZero],
})
export class SortingComponent implements OnInit {
  @Input() data:ISingleSortingQuestion = <ISingleSortingQuestion>{};
  @Input() questionNumber:number = -1;
  @Input() config:any;
  @Input() nextPage$:Observable<boolean> = new Observable<boolean>();
  @Input() answers:IAnswer[] = []
  @Output() dataEmitter:EventEmitter<IAnswer> = new EventEmitter<IAnswer>();
  
  checkFormGroup:boolean = false;
  mainColor:string = ''
  textColor:string = ''
  outputData:IAnswer = {
    id: 0,
    answer: [],
    valid: false,
    isUnknown: false,
  }

  commentStatus:BehaviorSubject<boolean> = new BehaviorSubject(false)
  commentStatusObs$:Observable<boolean> = this.commentStatus.asObservable()
  
  extraData:IData = <IData>{};
  answer:IOption[] = [];
  question:IOption[] = [];
  isUnknownInital:boolean | null = null;
  warnAnswer:BehaviorSubject<string> = new BehaviorSubject('no-shadow')
  warnAnswerObs:Observable<string> = this.warnAnswer.asObservable()
  translate:boolean = false;
  placeholderObj:any = {
    "0" : "اول",
    "1" : "دوم",
    "2" : "سوم",
    "3" : "چهارم",
    "4" : "پنجم",
    "5" : "ششم",
    "6" : "هفتم",
    "7" : "هشتم",
    "8" : "نهم",
  }

  constructor(
    private criteriaService:CriteriaService,
    private toastr:ToastrService,
  ){}

  ngOnInit(): void {
    this.setInitalDatas()
    this.nextPageAction()
  }

  placeholderItem(pointAnwserList:number[],i:number){
    if(i<pointAnwserList.length) return `اولویت ${this.placeholderObj[i as any]} خود را قرار دهید`
    else return ''
  }

  setInitalDatas(){
    let questionJSON = JSON.stringify(this.data.options)
    this.getInitialData(JSON.parse(questionJSON))
    this.mainColor = `background-color: ${this.data.additional_fields.main_color};`
    this.textColor = `color: ${this.data.additional_fields.text_color};`
  }
  changeCommentState(){
    this.commentStatus.next(!this.commentStatus.value)
  }
  updateExpandSecData(data:IData){
    this.extraData = data
  }
  sendComment(){
    let form:FormData = new FormData()
    form.append('comment', JSON.stringify(this.extraData.comment))
    this.criteriaService.sendQuestionComment(this.config.quizUserName, this.data.id, form).subscribe(
      ()=>{
        this.commentStatus.next(!this.commentStatus.value)
        this.toastr.success('نظر شما با موفقیت ارسال گردید')
      },
      ()=>{
        this.toastr.error('مشکلی در ارسال نظر شما پیش آمده')
      }
    )
  }
  getCustomStyle():string{
    return `min-height: ${((this.answer.length+this.question.length)*27.5)+227.5}px`
  }
  getOptionBackgroundColor(index: number): string {
    // Remove # from hex code
    let hex = this.data.additional_fields.main_color.replace("#", "");
  
    // Convert each pair of digits to decimal
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let opacity = 100
    if(index==this.answer.length - 1) opacity = 20
    if(index==0) opacity = 100
    if(index!=0 && index!=this.answer.length - 1){
      opacity = 100 -  (80/(this.answer.length - 1)*index)
    }
    return `background-color: rgba(${r}, ${g}, ${b}, ${opacity/100});`;
  }
  drop(event: CdkDragDrop<any>, isAnswer:boolean) {
    if (event.previousContainer === event.container){
      // console.log(event.previousContainer,event.container,isAnswer)
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      
      if (isAnswer && this.answer.length>this.data.additional_fields.point_of_answer_positions.length) {
        this.translate = true;
        this.warnAnswer.next('shadow')
        // console.log(this.answer, this.question, this.answer.length-1, 0)
        transferArrayItem(this.answer, this.question, this.answer.length-1, 0)
        setTimeout(() => {
          this.warnAnswer.next('no-shadow')
          this.translate = false;
        }, 600);
      }
    }
    if(this.config.isRealTime)
      this.sendOutputData(false)
  }
  
  sendOutputData(nextPage:boolean){
    this.outputData.id = this.data.id;
    this.outputData.isUnknown = this.extraData.isUnknown?true:false;
    this.outputData.answer = this.answer.length>0?this.answer.map(obj=>obj.id):[]
    this.outputData.valid = this.outputData.answer.length >= this.data.additional_fields.minimum_required_answer
    if(this.outputData.isUnknown)
      this.outputData.valid = true;
    this.checkFormGroup = nextPage;

    this.dataEmitter.emit(this.outputData)
  }
  nextPageAction(){
    this.nextPage$.pipe(
      map(i=>this.sendOutputData(i)),
    ).subscribe()
  }
  getErrorStyle(){
    let condition:boolean = this.checkFormGroup&&(this.answer.length<this.data.additional_fields.minimum_required_answer)&&this.data.is_answer_required&&(!this.extraData || !this.extraData.isUnknown)
    return {
      'box-shadow': condition?'0 0 2px 2px rgba(255, 0, 0, 0.507)':'',
      'background-color': condition?'rgb(255 1 1 / 10%)':'',
    }
  }
  getInitialData(options:IOption[]){
    let answerIndex:number = this.answers.findIndex(element=>element.id===this.data.id)
    if(answerIndex==-1){
      this.question = options
    }else{
      this.isUnknownInital = this.answers[answerIndex].isUnknown
      let answerOptions:number[] = this.answers[answerIndex].answer
      answerOptions.forEach(a=>{this.answer.push(options[options.findIndex(o=>o.id==a)])})
      this.question = options.filter(q=>answerOptions.findIndex(a=>a==q.id)<=-1)
    }
  }
}
